export const getImageFileResolution = (file: File) =>
	new Promise<{ width: number; height: number }>((resolve, reject) => {
		if (!file.type.startsWith('image/')) return reject('Invalid image file')

		const img = new Image()
		const objectURL = URL.createObjectURL(file)

		img.onload = () => {
			resolve({ width: img.width, height: img.height })
			URL.revokeObjectURL(objectURL)
		}

		img.onerror = reject
		img.src = objectURL
	})
